/**
 * @description 用于设置和响应主题变化的 Hook
 */
import {useEffect} from 'react';

enum Theme {
    Dark = 'dark',
    Light = 'light',
}

export {Theme};

export function useTheme(defaultTheme: Theme = Theme.Dark) {
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', Theme.Dark);
    }, [defaultTheme]);
}
